import { Box, BoxProps, Flex, Text } from '@chakra-ui/react';

import { IconBox } from '~/components/IconBox';
import {
  TiktokNoBorderIcon,
  YoutubeNoBorderIcon,
  InstagramNoBorderIcon,
} from '~/components/icons';
import { SOCIAL_PLATFORMS_NAMES } from '~/constants/social_platforms_names';

import { BoxStyles, TextStyles } from '../Footer.styles';

export const FooterPartners: React.FC<BoxProps> = props => {
  return (
    <Box display="inline-flex" paddingRight={12} {...props} {...BoxStyles}>
      <Flex alignItems="flex-end" flexWrap="wrap">
        <IconBox
          backgroundColor="primary.500"
          boxSize={4}
          marginRight={2}
          icon={
            <TiktokNoBorderIcon
              aria-label={`${SOCIAL_PLATFORMS_NAMES.tiktok} Partner`}
              boxSize="0.6rem"
              color="white"
            />
          }
        />
        <IconBox
          backgroundColor="primary.500"
          boxSize={4}
          marginRight={2}
          icon={
            <InstagramNoBorderIcon
              aria-label={`${SOCIAL_PLATFORMS_NAMES.instagram} Partner`}
              boxSize="0.6rem"
              color="white"
            />
          }
        />
        <IconBox
          backgroundColor="primary.500"
          boxSize={4}
          marginRight={2}
          icon={
            <YoutubeNoBorderIcon
              aria-label={`${SOCIAL_PLATFORMS_NAMES.youtube} Partner`}
              boxSize="0.6rem"
              color="white"
            />
          }
        />
        <Text {...TextStyles}>Partners</Text>
      </Flex>
    </Box>
  );
};
